import type { CartItem, SavedDelivery } from '../context/CartContext';
import { withCartAmount } from './cartMoney';

export function isValidSavedDelivery(value: unknown): value is SavedDelivery {
  if (!value || typeof value !== 'object') return false;
  const { details, cost } = value as { details?: unknown; cost?: unknown };
  if (!details || typeof details !== 'object' || !cost || typeof cost !== 'object') return false;
  const d = details as Record<string, unknown>;
  return typeof d.destination === 'string' && typeof d.origin === 'string'
    && typeof d.date === 'string' && typeof d.slot === 'string'
    && typeof (cost as Record<string, unknown>).cost === 'number';
}

function addonTargetTitle(item: Pick<CartItem, 'attributes'>): string | null {
  if (!Array.isArray(item.attributes)) return null;
  return item.attributes.find(attribute => attribute?.key === 'Do zamówienia')?.value?.trim() || null;
}

export function isCartAddon(item: Pick<CartItem, 'attributes' | 'parentItemId'>): boolean {
  return Boolean(item.parentItemId || addonTargetTitle(item));
}

/** Migrate old localStorage lines without discarding valid gifts or charging orphaned add-ons. */
export function restoreCartItems(raw: unknown): CartItem[] {
  if (!Array.isArray(raw)) return [];
  const migrated: CartItem[] = [];
  const mainIds = new Set<string>();
  const latestByTitle = new Map<string, string>();
  for (const stored of raw) {
    if (!stored?.id || !stored.productTitle) continue;
    const item: CartItem = withCartAmount(stored.delivery && !isValidSavedDelivery(stored.delivery)
      ? { ...stored, delivery: undefined } : stored);
    const targetTitle = addonTargetTitle(item);
    if (targetTitle || item.parentItemId) {
      const parentItemId = item.parentItemId && mainIds.has(item.parentItemId)
        ? item.parentItemId : targetTitle ? latestByTitle.get(targetTitle) : undefined;
      if (!parentItemId || !mainIds.has(parentItemId)) continue;
      migrated.push({ ...item, parentItemId });
    } else {
      migrated.push(item);
      mainIds.add(item.id);
      latestByTitle.set(item.productTitle, item.id);
    }
  }
  return migrated;
}
